/**
 * Constructor :
 * - model : global model
 * - options :
 *     	- filtersDisabled : disable filters
 * 		- automaticPlacingDisabled : disable automatic placing
 */
fx.ns("desktop.common.panels", class PhotosPanel extends fx.components.Box {
    
	constructor(model, options)
	{
		super();

		this.model = model;
		this.data = model.photos;
		this.creation = model.creation; //book;

		this.options = options;
		//this.__loading = false;

		this.listenUpdates(this.creation);
		this.listenUpdates(this.model.sharedPhotos);
	}

	
	get data()
	{
		return super.data;
	}

	set data(val)
	{
		if (val instanceof fx.ModelArray)
		{
			super.data = val;

			if (this.grid)
				this.grid.data = val;
		}
		else
		if (val)
		{
			this.model = val;
			this.data = val.photos;
			this.creation = val.creation;

			if (this.filtersButton)
				this.filtersButton.data = val;
			
		}
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		if (this._book)
			this.listenUpdates( this._book, false);

		this._book = val;

		if (this._book)
			this.listenUpdates( this._book, true);

		
	}
	 
	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}

    get photofilters()
    {
        return this.model.photosorts;
    } 


	onReady()
	{
		super.onReady();

		this.on("click", this.addPhoto, this.button);	
		this.on("click", this._hideCreateAlbumToolTip, document);

		if (this.creation)
			this._initFilter()
		
		if (this.magicButton)
		{
			this.on("click", this.onMagic, this.magicButton);
			this.on("mouseover", this._showCreateAlbumToolTip, this.magicButton);
            this._updateMagicButton();
		}

		// one-time selection hints (book editor only)
		if (this._multiSelect && this.grid)
			this.on("selection-count-changed", this._onSelectionCountChanged, this.grid);

	}

	create()
	{
		super.create();

		// add photo button and filters
		this.boxActions = new fx.components.Box("actions");

		
		if (this.options == undefined || !this.options.automaticPlacingDisabled)
		{
			this.magicButton = new fx.components.IconButton({icon : fx.get("assets").magicIcon, className : "magic"});
            this.boxActions.addChild(this.magicButton, {width : 40, height : 40, left: 290, top : 11});
		}

		if (this.options == undefined || !this.options.filtersDisabled)
		{
			this.filtersButton = new desktop.common.panels.PhotoFilters( this.model);
			this.boxActions.addChild(this.filtersButton, {width : 50, left : this.magicButton ? 250 : 280, top : 11, height:50});
			this.filtersButton.toolTip = fx.text("Trier / filtrer vos photos");
		}

        if (this.options == undefined || !this.options.addPhotoDisabled)
        {
            this.button = new fx.components.Button({label : fx.text("Ajouter des photos"), icon : fx.get("assets").cameraAdd, className : "add"});
            this.boxActions.addChild(this.button, {left: 0, top : 0, width : (!this.magicButton && !this.filtersButton) ? "100%" : (this.magicButton ? 250 : 280)});
        }
    

		if (this.options == undefined || !this.options.addPhotoDisabled || !this.options.filtersDisabled || !this.options.automaticPlacingDisabled)
			this.addChild(this.boxActions, { width : "100%", height : 60, top : 15});

		// multiSelect (book editor) -> selectable grid ; otherwise the plain grid
		let GridClass = this._multiSelect ? shared.components.SelectablePhotoGrid : fx.components.VerticalGridDynamic;
		let photoRenderer = this._multiSelect ? shared.renderers.PhotoSelectableRenderer : shared.renderers.PhotoRenderer;

		this.grid = new GridClass( {	data : this.data,
										renderers : {Photo : photoRenderer},
										scrollOnNew : true,
										hasOnlyUnique : true,
										newChildEffect : "scale",
										maxRowHeight : 150
									 } );

		this.addChild(this.grid, {height:"fill", left : 2, right : 2, top : 90});
	}


	onFilterUserChanged(event)
	{

	}

	addPhoto(e)
	{
        //fx.set("photo-selected", null);
		//this.data.event("selectphotos", this.model);
        this.data.event("selectphotos");
	}

	onMagic()
	{
		if (this.data.active.length > 0)
			this.data.event("place-photos-chronologically");
	}

	onChildUpdated(action)
	{
		//if (action.model instanceof models.Photo)
        if (action.model instanceof models.CreationElementContent || action.model instanceof models.Photo)
		{
			//if (action.impacts("number"))
            if (action.impacts("content") || action.impacts("number") || action.impacts("validated"))
				this.delay( this._updateGrid, 250);

			if (this.magicButton)
				this.magicButton.toggleClass("enabled", this.data.active.length > 0);
		}

        if(action.model instanceof models.Photo && action.impacts("processing"))
        {
            this.loading(action.model.processing);
        }
		
	}

    _updateGrid()
    {
        if (this.grid)
            this.grid.forceUpdate();
    }

    _initFilter()
    {
        if (this.grid && this.creation)
        {
            let filter = this.photofilters.getItemAt( this.creation.photosSort );	
            filter.photosused = this.creation.showphotosused;
            this.grid.filter = filter;
        }
    }
	onDataUpdated(action)
	{
		// if photos are added, let's switch filer to added
		// and let's not do it for 30 secondes (average time of loading large amount of pictures)

		if (action.model instanceof models.ProductBook)
		{
			if (action.type == "init")
				this._initFilter();
		}
		else
		if (action.type == "addItem" && action.data.length === undefined && !this._switchSelectTimer)
			this.delay(this._clearTimerSwitch, 30000);

		if (action.model == this.creation)
		{
			if (action.impacts("photosort"))
			{
                this._initFilter();
				// a filter/sort change can hide selected photos -> reset the selection
				if (this._multiSelect)
					this._clearSelection();
			}

			if (action.impacts("showphotosused"))
			{
				this.grid.filter.photosused = this.creation.showphotosused;
				if (this._multiSelect)
					this._clearSelection();
			}
		}

		this._updateMagicButton();
			
	}

    _updateMagicButton()
    {
        if (this.magicButton)
        {
            let enabled = this.data.active.length > 0;
            this.magicButton.toolTip = enabled ? fx.text("Placer vos photos automatiquement") : fx.text("Ajoutez des photos puis cliquez ici pour les placer automatiquement");
            this.magicButton.toggleClass("enabled", enabled);
        }
    }

	get _multiSelect()
	{
		return !!(this.options && this.options.multiSelect);
	}

	// clear the selection over the full photos array (incl. photos hidden by the filter)
	_clearSelection()
	{
		if (this.data)
		{
			for (let i = 0; i < this.data.length; i++)
			{
				let p = this.data.getItemAt(i);
				if (p && p.selected)
					p.selected = false;
			}
		}

		if (this.grid && this.grid.onSelectionChanged)
			this.grid.onSelectionChanged();
	}

	onDataEvent(e)
    {
		if (e.type == "propose-magic-placement")
			this._showCreateAlbumToolTip();

		if (e.type == "clear-photos-selection")
		{
			this._clearSelection();
			this._hideSelectionHint();
		}

		if (e.type == "photo-selection-changed")
		{
			if (this.grid && this.grid.onSelectionChanged)
				this.grid.onSelectionChanged(e.detail && e.detail.photo);
		}

		if (e.type == "share-upload-validated")
		{
			if(e.detail.photo)
				this.grid.scrollToElement(e.detail.photo);
		}
	}

	_showCreateAlbumToolTip()
	{
		if (!this.magicButton || this.data.active.length < 10)
			return;
			
		if (!this._createAlbumToolTip)
		{
			this._createAlbumToolTip = new desktop.book.edition.CreateAlbumToolTip(this.data);	
			this.addChild(this._createAlbumToolTip, { width : 385, height : 100, top : this.boxActions.y + this.magicButton.y - (100 - this.magicButton.realHeight) / 2, left : this.magicButton.x + this.magicButton.realWidth + 40});
		}
		else
			this._createAlbumToolTip.show();

		this.delay(this._hideCreateAlbumToolTip, 5000);
	}

	_hideCreateAlbumToolTip()
	{
		if (this._createAlbumToolTip)
			this._createAlbumToolTip.hide();
	}

	// one-time onboarding hints, fired by the grid on every selection change. Only react
	// when the count went UP (a photo was added), so deselecting never pops a hint.
	_onSelectionCountChanged(e)
	{
		if (!e || !e.detail) return;

		let count = e.detail.count;
		let increased = count > (this._lastSelCount || 0);
		this._lastSelCount = count;

		if (!increased) return;

		if (count >= this.grid.maxSelection)
			this._showSelectionHint("limit", e.detail.photo);
		else if (count >= 2)
			this._showSelectionHint("multidrag", e.detail.photo);
	}

	// show a hint once ever (persisted in localStorage), anchored next to `photo`
	_showSelectionHint(kind, photo)
	{
		let key = (kind == "limit") ? "fl-hint-select-limit" : "fl-hint-multidrag";
		if (this._hintSeen(key)) return;
		this._markHintSeen(key);

		let text = (kind == "limit")
			? fx.text("Vous pouvez sélectionner $ photos maximum.", this.grid.maxSelection)
			: fx.text("Glissez vos photos sur l'album pour les placer.");

		if (this._selectionHint)
		{
			this.removeChild(this._selectionHint, true);
			this._selectionHint = null;
		}

		// horizontally just outside the panel (to its right); vertically aligned to the
		// triggering photo, falling back to a fixed spot if it is scrolled out of the grid.
		let width = 340, height = 88, gap = 24;
		let left = (this.node ? this.node.offsetWidth : 360) + gap;
		let top = 200;

		let node = (photo && this.grid && this.grid.node)
			? this.grid.node.querySelector('.PhotoRenderer[data-id="' + photo.id + '"]')
			: null;

		if (node)
		{
			let panelOff = fx.dom.offset(this.node);
			let off = fx.dom.offset(node);
			top = (off.top - panelOff.top) + node.offsetHeight / 2 - height / 2;
		}

		this._selectionHint = new desktop.book.edition.SelectionHintToolTip({ text : text });
		this.addChild(this._selectionHint, { width : width, height : height, left : left, top : top });

		this.delay(this._hideSelectionHint, 6000);
	}

	_hideSelectionHint()
	{
		if (this._selectionHint)
			this._selectionHint.hide();
	}

	// per-session : each hint shows once while the editor is open, and again after a reload
	_hintSeen(key)
	{
		return !!(this._hintsSeen && this._hintsSeen[key]);
	}

	_markHintSeen(key)
	{
		if (!this._hintsSeen) this._hintsSeen = {};
		this._hintsSeen[key] = true;
	}

	_clearTimerSwitch()
	{
		this._switchSelectTimer = null;
	}

	selectFilter(index)
	{
		this.filtersButton.selectFilter(index);
	}


	
		
});
